module.exports = __webpack_public_path__ + "static/media/timeline_desktop.38d19c78.svg";